import script from "./media-article.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./media-article.vue?vue&type=script&setup=true&lang=ts"
export * from "./media-article.vue.ts?vue&type=script&setup=true&lang=ts!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./media-article.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__